import script from "./UtilizeMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./UtilizeMobile.vue?vue&type=script&setup=true&lang=ts"

import "./UtilizeMobile.vue?vue&type=style&index=0&id=78992b87&lang=scss&scoped=true"

import exportComponent from "/var/www/digital-card-solution-limited/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78992b87"]])

export default __exports__